module.exports = __webpack_public_path__ + "static/media/cancel_payment.e3a9688c.svg";